import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Input, Button, Table, Popconfirm, message } from 'antd';
import { CopyOutlined, DeleteOutlined, EditOutlined, PlusCircleOutlined, SearchOutlined } from '@ant-design/icons';
import axios from '../utils/axios';
import BreadCrumb from '../components/Breadcrumb';
import TextFilter from '../components/TextFilter';

function Testimonials() {
	const [gridLoading, setGridLoading] = useState(true);
	const [gridData, setGridData] = useState([]);
	const [totalRecords, setTotalRecords] = useState(0);
	const [gridHeight, setGridHeight] = useState(window.innerHeight - 182);

	const get = (options = {}) => {
		if (!options.pagination) {
			options.pagination = { start: 0, limit: 20 };
		} else {
			options.pagination = {
				start: (options.pagination.current - 1) * options.pagination.pageSize,
				limit: options.pagination.pageSize,
			};
		}

		if (options.sorter && options.sorter.order) {
			options.sorter = {
				field: options.sorter.field,
				order: options.sorter.order,
			};
		} else {
			options.sorter = { field: '_id', order: 'desc' };
		}

		axios
			.get(`/testimonials`, { params: options })
			.then((result) => {
				setGridData(result.data.data);
				setTotalRecords(result.data.data.length);
			})
			.finally(() => {
				setGridLoading(false);
			});
	};

	const deleteRecord = (record) => {
		setGridLoading(true);
		axios
			.delete(`/testimonials`, { data: { _id: record._id } })
			.then((result) => {
				message.success(result.data.message);
				get();
			})
			.catch(() => {
				message.error('Oops! Something went wrong!');
			})
			.finally(() => {
				setGridLoading(false);
			});
	};

	const duplicateRecord = (record) => {
		setGridLoading(true);
		axios
			.post(`/testimonials/duplicate`, { data: { _id: record._id } })
			.then((result) => {
				message.success(result.data.message);
				get();
			})
			.catch(() => {
				message.error('Oops! Something went wrong!');
			})
			.finally(() => {
				setGridLoading(false);
			});
	};

	const onTableChange = (pagination, filters, sorter) => {
		get({ pagination, filters, sorter });
	};

	useEffect(() => {
		get();
		window.onresize = () => {
			setGridHeight(window.innerHeight - 182);
		};
	}, []);

	return (
		<>
			<BreadCrumb breadcrumbs={[{ link: '/', label: 'Home' }, { label: 'Testimonials' }]} />
			<div className='main-content'>
				<div className='page-header'>
					<div className='page-title'>Testimonials</div>
					<div className='page-title-more'>
						<Input.Search placeholder='Search' style={{ width: '140px' }} />
						<Link to='/testimonials/add'>
							<Button icon={<PlusCircleOutlined />} type='primary'>
								Add
							</Button>
						</Link>
					</div>
				</div>
				<div className='grid-content'>
					<Table
						tableLayout='fixed'
						bordered
						size='small'
						rowKey='_id'
						showSorterTooltip={false}
						loading={gridLoading}
						dataSource={gridData}
						scroll={{ x: 850, y: gridHeight }}
						onChange={onTableChange}
						pagination={{
							defaultPageSize: 20,
							showLessItems: true,
							showQuickJumper: true,
							showSizeChanger: true,
							pageSizeOptions: [20, 50, 100, 200],
							size: 'small',
							responsive: true,
							total: totalRecords,
							showTotal: (total) => `Total ${total} items`,
						}}
						columns={[
							{
								title: 'Action',
								key: 'action',
								align: 'center',
								fixed: 'left',
								width: 104,
								render: (text, record) => (
									<div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
										<Link to={`/testimonials/edit/${record._id}`}>
											<EditOutlined className='grid-edit-icon' title='Edit' />
										</Link>
										<Popconfirm
											title='Are you sure you want to duplicate this record?'
											okText='Yes'
											cancelText='No'
											size='small'
											placement='bottomLeft'
											onConfirm={() => {
												duplicateRecord(record);
											}}
										>
											<CopyOutlined style={{ fontSize: 14 }} title='Duplicate' />
										</Popconfirm>
										<Popconfirm
											title='Are you sure you want to delete this record?'
											okText='Yes'
											cancelText='No'
											size='small'
											placement='bottomLeft'
											onConfirm={() => {
												deleteRecord(record);
											}}
										>
											<DeleteOutlined style={{ fontSize: 14 }} title='Delete' />
										</Popconfirm>
									</div>
								),
							},
							{
								title: 'Name',
								dataIndex: 'name',
								sorter: true,
								ellipsis: true,
								width: 200,
								filterDropdown: () => <TextFilter />,
								filterIcon: <SearchOutlined />,
							},
							{
								title: 'Role',
								dataIndex: 'role',
								ellipsis: true,
								width: 200,
							},
							{
								title: 'Feedback',
								dataIndex: 'feedback',
								ellipsis: true,
							},
							{
								title: 'Rating',
								dataIndex: 'rating',
								sorter: true,
								width: 100,
							},
						]}
					/>
				</div>
			</div>
		</>
	);
}

export default Testimonials;
